//projectlab-web/src/components/ui/PageLoader.tsx
export function PageLoader() {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--color-bg)]"
      role="status"
      aria-label="Loading ProjectLab"
    >
      <div className="flex flex-col items-center gap-5">
        {/* Animated logo mark */}
        <div className="relative">
          <svg
            viewBox="0 0 48 48"
            width="48"
            height="48"
            fill="none"
            aria-hidden="true"
            className="animate-pulse-slow"
          >
            <rect x="4"  y="4"  width="17" height="17" rx="3.5" fill="#1E5CFF" />
            <rect x="27" y="4"  width="17" height="17" rx="3.5" fill="#4A7DFF" opacity="0.75" />
            <rect x="4"  y="27" width="17" height="17" rx="3.5" fill="#4A7DFF" opacity="0.75" />
            <rect x="27" y="27" width="17" height="17" rx="3.5" fill="#1E5CFF" opacity="0.45" />
          </svg>
          {/* Spinning ring */}
          <svg
            viewBox="0 0 64 64"
            width="64"
            height="64"
            className="absolute -inset-2 animate-spin"
            style={{ animationDuration: '1.4s' }}
            aria-hidden="true"
          >
            <circle
              cx="32" cy="32" r="28"
              stroke="#1E5CFF"
              strokeWidth="2.5"
              strokeOpacity="0.25"
              fill="none"
            />
            <path
              d="M32 4 A28 28 0 0 1 60 32"
              stroke="#1E5CFF"
              strokeWidth="2.5"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </div>

        <div className="flex flex-col items-center gap-1">
          <p className="text-sm font-semibold text-[var(--color-text)]">ProjectLab</p>
          <p className="text-xs text-[var(--color-text-muted)]">Loading…</p>
        </div>
      </div>
    </div>
  );
}
